import {useEffect, useState} from "react";
import { RecaptchaVerifier } from "firebase/auth";
import {auth} from "../../firebase";

export function useRecaptcha(componentId) {
    const [recaptcha, setRecaptcha] = useState();

    useEffect(() => {
        const recaptchaVerifier = new RecaptchaVerifier(componentId, {
            "size": "invisible",
            "callback": () => {}
        }, auth);

        setRecaptcha(recaptchaVerifier);

        return () => {
            recaptchaVerifier.clear();
        }
    }, [componentId]);

    return recaptcha;
}